// extracted by mini-css-extract-plugin
export var callCard = "_rd-0";
export var callMessageButton = "_rd-1";
export var helpIcon = "_rd-3";
export var helpIconContainer = "_rd-4";
export var verticalDivider = "_rd-2";